<template>
	<div class="col-span-4 lg:col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
		<!-- Next Billing Cycle Amount -->
		<section class="flex items-center justify-between mb-6 lg:mb-0 panel">
			<div class="flex flex-col">
				<span class="text-sm uppercase text-mx-gray-500 dark:text-mx-gray-400">
					{{ t('account-page.next-billing.amount') }}
				</span>
				<span class="text-xl font-semibold">
					{{ nextBillingCycleAmount }}
				</span>
			</div>
			<IconDollarSign class="h-6 text-mx-gray-500 dark:text-mx-gray-400" />
		</section>

		<!-- Next Billing Cycle Date -->
		<section class="flex items-center justify-between panel">
			<div class="flex flex-col">
				<span class="text-sm uppercase text-mx-gray-500 dark:text-mx-gray-400">
					{{ t('account-page.next-billing.date') }}
				</span>
				<span class="text-xl font-semibold">
					{{ msdyDate }}
				</span>
			</div>
			<CalendarIcon class="h-6 text-mx-gray-500 dark:text-mx-gray-400" />
		</section>
	</div>
</template>

<script setup lang="ts">
import { CalendarIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

interface Props {
	nextBillingCycleAmount: string
	msdyDate: string
}

defineProps<Props>()

const { t } = useI18n()
</script>
